/* eslint-disable max-lines-per-function */
import { SharedContext } from '@/domain/dienstplan/features/VisualEditor/hooks/useVisualEditor/types';
import { Intersection } from '@/domain/dienstplan/features/VisualEditor/utils/mouseHelper/isMouseIntersectInterval';
import { formatHourDecimalToTimeString } from '@/domain/dienstplan/features/VisualEditor/utils/timeHelper/formatHourDecimalToTimeString';
import {
  Belegung,
  BelegungsIntervall,
} from '@/domain/dienstplan/shared/types/Belegung';
import { toast } from '@/hooks/use-toast';
import { sendUserMetric } from '@/services/userbeat/userbeat';

export function endBelegungResize({
  ctx,
  collision,
}: {
  ctx: SharedContext;
  collision?: Intersection;
}) {
  const { belegungen } = ctx;

  const activeBelegungIntervall = belegungen.find(
    (b) => b.mode === 'resize' || b.mode === 'resize-height',
  );
  if (!activeBelegungIntervall) return;
  if (collision === undefined || collision.isIntersect === false) {
    const newActiveInterval = new BelegungsIntervall(
      activeBelegungIntervall.belegung,
      'inactive',
    );

    updateBelegung(newActiveInterval, activeBelegungIntervall, ctx);
    return;
  }
  const updatedActiveBelegung = new BelegungsIntervall(
    new Belegung({
      ...activeBelegungIntervall.belegung,
      start:
        collision.collision.direction === 'west'
          ? collision.collision.interfall.belegung.ende
          : activeBelegungIntervall.belegung.start,
      ende:
        collision.collision.direction === 'east'
          ? collision.collision.interfall.belegung.start
          : activeBelegungIntervall.belegung.ende,
    }),
    activeBelegungIntervall.mode,
  );
  const inactiveInterval = new BelegungsIntervall(
    updatedActiveBelegung.belegung,
    'inactive',
  );

  updateBelegung(inactiveInterval, updatedActiveBelegung, ctx);
}

function updateBelegung(
  newActiveInterval: BelegungsIntervall,
  activeBelegung: BelegungsIntervall,
  ctx: SharedContext,
) {
  const {
    store: {
      removeBelegungById,
      setStartBelegungPosition,
      setIsResizingStart,
      setIsResizingEnde,
      updateBelegungById,
      setPopoverPosition,
      setIsPopoverOpen,
      setHoveredBelegung,
    },
    deleteBelegung,
  } = ctx;
  updateBelegungById(newActiveInterval, newActiveInterval.belegung.id);

  if (
    activeBelegung.belegung.start === activeBelegung.belegung.ende ||
    activeBelegung.belegung.personenanzahlMax <= 0
  ) {
    deleteBelegung({ belegungId: activeBelegung.belegung.id }).then(() => {
      removeBelegungById(activeBelegung.belegung.id);
      setStartBelegungPosition(undefined);
      setIsResizingStart(false);
      setIsResizingEnde(false);
      setPopoverPosition(undefined);
      setHoveredBelegung(undefined);
      setIsPopoverOpen(false);
    });
  } else {
    setStartBelegungPosition(undefined);
    setIsResizingStart(false);
    setIsResizingEnde(false);
    setPopoverPosition(undefined);
    setHoveredBelegung(undefined);
    setIsPopoverOpen(false);
    ctx
      .updateBelegung({
        input: {
          anzahlMitarbeiter: activeBelegung.belegung.personenanzahlMax,
          dauer: activeBelegung.width * 60,
          von: formatHourDecimalToTimeString(activeBelegung.belegung.start, 0),
          id: activeBelegung.belegung.id,
        },
      })
      .then(() => {
        sendUserMetric();
        toast({
          title: ctx.t(
            'domain.dienstplan.mindestbelegung.visualEditor.updateSuccess',
          ),
        });
      });
  }
}
